import * as React from "react";
import { StyledErrorScreen } from "./styles";
import { ErrorScreenTypeProps } from "./types";

import { BottomNav } from "../BottomNav";
import { Header } from "../Header";

export const ErrorScreen = ({
  imageSrc,
  content,
  style,
}: ErrorScreenTypeProps) => {
  return (
    <StyledErrorScreen style={style}>
      <Header hideText />
      {imageSrc && <img height="200px" src={imageSrc} alt="error" />}
      <h4>Something went wrong!</h4>
      {content && <p>{content}</p>}
      <BottomNav />
    </StyledErrorScreen>
  );
};
